export default [
    {
        name: 'level',
        type: 'gltfModel',
        path: 'models/level.glb'
    },
    {
        name: 'level_albedo',
        type: 'texture',
        path: 'textures/level/level_albedo.jpg'
    },
    {
        name: 'foliage_albedo',
        type: 'texture',
        path: 'textures/level/foliage_albedo.jpg'
    },
    {
        name: 'foliage_opacity',
        type: 'texture',
        path: 'textures/level/foliage_opacity.jpg'
    },
    {
        name: 'emission_albedo',
        type: 'texture',
        path: 'textures/level/emission_albedo.jpg'
    },
    {
        name: 'water_displacement',
        type: 'texture',
        path: 'textures/water/water_displacement.jpg'
    },
    {
        name: 'water_color',
        type: 'texture',
        path: 'textures/water/water_color.jpg'
    },
    {
        name: 'water_flowmap',
        type: 'texture',
        path: 'textures/water/flowmap.jpg'
    },
    {
        name: 'daxter',
        type: 'gltfModel',
        path: 'models/daxter.glb'
    },
    {
        name: 'jak',
        type: 'gltfModel',
        path: 'models/jak.glb'
    },
    {
        name: 'net',
        type: 'gltfModel',
        path: 'models/net.glb'
    },
    {
        name: 'smallFish',
        type: 'gltfModel',
        path: 'models/smallFish_.glb'
    },
    {
        name: 'bigFish',
        type: 'gltfModel',
        path: 'models/bigFish_.glb'
    },
    {
        name: 'badFish',
        type: 'gltfModel',
        path: 'models/badFish_.glb'
    },
    {
        name: 'smallFish_texture',
        type: 'texture',
        path: 'textures/fish/green_color.jpg'
    },
    {
        name: 'badFish_texture',
        type: 'texture',
        path: 'textures/fish/bad_color.jpg'
    },
    {
        name: 'bigFish_texture',
        type: 'texture',
        path: 'textures/fish/big_color.jpg'
    },
    {
        name: 'smallFish_sound',
        type: 'audio',
        path: 'sounds/small.ogg'
    },
    {
        name: 'bigFish_sound',
        type: 'audio',
        path: 'sounds/big.ogg'
    },
    {
        name: 'lose_sound',
        type: 'audio',
        path: 'sounds/lose.ogg'
    },
    {
        name: 'miss_sound',
        type: 'audio',
        path: 'sounds/miss.ogg'
    },
    {
        name: 'music',
        type: 'audio',
        path: 'sounds/music.ogg'
    }
]